import React from "react";
import TabPane from "../../../components/Tab/TabPane";
import CommonSelect from "../../../components/forms/CommonSelect";
import CommonButton from "../../../components/buttons/CommonButton";
import TabHelper from "../../../helpers/TabHelper";
import Format from "../../../helpers/Format";
import PropTypes from "prop-types";

function ClienteTab({
  tabAtualHook,
  valuesHook,
  clientesHook,
  checkClientesTab,
  togNovoClienteModal,
}) {
  const { tabAtual, setTabAtual } = tabAtualHook;
  const { values, setValues } = valuesHook;
  const { clientes } = clientesHook;

  return (
    <TabPane id="clienteTab" ativo={true}>
      <div className="row mb-3">
        <div className="col-12">
          <CommonSelect
            label="Cliente"
            id="cliente"
            value={values.cliente}
            onChange={(e) => {
              const selectedOption = e.target.options[e.target.selectedIndex];
              const selectedSimples = selectedOption
                ? selectedOption?.dataset?.simples
                : null;

              setValues({
                ...values,
                [e.target.name]: e.target.value,
                optanteSimples: selectedSimples === "1",
              });
            }}
            data={
              clientes &&
              clientes.map((cliente) => ({
                text: `${cliente.razao_social} ${
                  cliente.cnpj
                    ? `(${Format.formatCNPJCPF(cliente.cnpj, "Exterior")})`
                    : ""
                }`,
                id: cliente.uid,
                "data-simples": cliente.optante_simples,
              }))
            }
            placeholder="Selecione o cliente"
            required
          />
        </div>
      </div>
      <div className="row d-flex justify-content-between mx-1">
        <CommonButton
          onClick={() => {
            togNovoClienteModal();
          }}
          color="success"
        >
          Cadastrar cliente
        </CommonButton>
        <CommonButton
          onClick={() => {
            if (checkClientesTab())
              TabHelper.trocarTab(tabAtual, setTabAtual, 1);
          }}
          color="primary"
        >
          Próximo
        </CommonButton>
      </div>
    </TabPane>
  );
}

ClienteTab.propTypes = {
  tabAtualHook: PropTypes.shape({
    tabAtual: PropTypes.number.isRequired,
    setTabAtual: PropTypes.func.isRequired,
  }).isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  clientesHook: PropTypes.shape({
    clientes: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  checkClientesTab: PropTypes.func.isRequired,
  togNovoClienteModal: PropTypes.func.isRequired,
};

export default ClienteTab;
